import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { CalendarBlockIcon, CalendarDateIcon, CalendarIcon } from '@calendly/ui/components/icons'

import { useEventType } from 'features/event_type_provider'
import { useTrackAvailabilityInteraction } from 'hooks/analytics_events/use_track_availability_interaction'


export const CalendarViewControl = ({
  onClick,
  variant = 'legacy',
  isActive = false,
}) => {
  const eventType = useEventType()
  const isV4 = variant === 'v4'

  let Icon = CalendarIcon
  let decoration = 'secondary-outline'

  if (isV4) {
    Icon = isActive ? CalendarBlockIcon : CalendarDateIcon
    decoration = isActive ? 'secondary-outline' : 'ghost'
  }

  const label = isActive
    ? I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.hide_calendar')
    : I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.view_calendar')

  const trackViewCalendar = useTrackAvailabilityInteraction({
    eventType,
    location: 'et_editor',
    action: 'view_calendar'
  })

  const handleClick = (event) => {
    if (!isActive) {
      trackViewCalendar()
    }
    return onClick(event)
  }

  return (
    <Button
      decoration={decoration}
      onClick={handleClick}
      size="small"
      aria-pressed={isActive}
      data-testid="calendar-view-control"
      data-active={isActive ? 'true' : 'false'}
    >
      <Icon />
      {label}
    </Button>
  )
}
